import { Divider, List, ListItemButton, ListItemText } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { masterFormList } from "./config/masterFormList";

export default function MasterFormList() {
    const { t } = useTranslation("masterForms");

    const list = masterFormList;

    return (
        <List>
            {list.map((form, index) => (
                <Fragment key={form.id}>
                    <ListItemButton component={Link} to={form.path} sx={{ paddingLeft: 0 }}>
                        <ListItemText
                            primary={t(`masterFormList.${form.translationKey}.name`)}
                            secondary={t(`masterFormList.${form.translationKey}.description`)}
                            sx={{ paddingLeft: 2 }}
                        />
                    </ListItemButton>
                    {list.length !== index + 1 && <Divider />}
                </Fragment>
            ))}
        </List>
    );
}
